<div class="timer-container">
	<div class="border-gradient-circle time">
		<div class="time-value">{{getDays()}}</div>
		<!-- <div class="time-name">jours</div> -->
    <span>{{ getDays() > 1 ? getSeparator('dd') + 's' : getSeparator('dd') }}</span>
	</div>

	<!-- <div class="separator"></div> -->
	<div class="separator"></div>
	<div class="border-gradient-circle time">
		<div class="time-value">{{getHours()}}</div>
		<!-- <div class="time-name">heures</div> -->
    	<span>{{ getHours() > 1 ? getSeparator('hh') + 's' : getSeparator('hh') }}</span>
  	</div>

	<div class="separator"></div>
	<div class="border-gradient-circle time">
		<div class="time-value">{{getMin()}}</div>
		<!-- <div class="time-name">min</div> -->
    	<span>{{ getMin() > 1 ? getSeparator('mm') + 's' : getSeparator('mm') }}</span>
  	</div>

	<div class="separator"></div>
	<div class="border-gradient-circle time">
		<div class="time-value">{{getSec()}}</div>
		<!-- <div class="time-name">sec</div> -->
    	<span>{{ getSec() > 1 ? getSeparator('ss') + 's' : getSeparator('ss') }}</span>
  	</div>
</div>
